import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { getMarketingCampaignById, removeMarketingCampaign } from '../../api/marketingService';
import { showDefault } from '../../redux/actions/snackbarActions';
import { Store } from '../../redux/store';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmDeleteCampaign = ({
    id,
    open,
    onClose
}) => {
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [name, setName] = useState();

    useEffect(() => {
        async function buscarPorId() {
            if (id) {
                setFetching(true);
                const response = await getMarketingCampaignById(id);
                setName(response.name);
                setFetching(false);
            }
        }
        buscarPorId();
    }, [id]);

    async function deleteCampaign() {
        setDeleting(true);
        await removeMarketingCampaign(id);
        Store.dispatch(showDefault('Campaign deleted.'));
        setName('');
        onClose();
        setDeleting(false);
    }

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={onClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">Delete campaign</DialogTitle>
            <DialogContent>
                {fetching && <CircularProgress />}
                <DialogContentText id="alert-dialog-slide-description">
                    You're deleting campaign {name}. This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Go back
                </Button>
                <Button onClick={deleteCampaign} color="secondary" disabled={deleting}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDeleteCampaign
